import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import config from '../../config'

import { IUseDeleteMutation, IDeleteFn, IGetDeleteRequest, ISafetyCaseHazardMitigation } from '../../interfaces'

const getDeleteSafetyCaseHazardMitigationMutationRequest: IGetDeleteRequest = () => ({
  method: 'delete',
  url: `${config.baseUrl}/sms/Mitigations/`,
})

const useDeleteSafetyCaseHazardMitigationMutation: IUseDeleteMutation<ISafetyCaseHazardMitigation, number> = (
  params,
  options = {},
) => {
  const request = useMemo(() => getDeleteSafetyCaseHazardMitigationMutationRequest(params), [params])

  const deleteSafetyCaseHazardMitigation: IDeleteFn<ISafetyCaseHazardMitigation> = useCallback(
    async id => axios({ ...request, url: request.url + id }).then(res => res.data),
    [request],
  )

  const response = useMutation<ISafetyCaseHazardMitigation, Error, any>({
    mutationFn: deleteSafetyCaseHazardMitigation,
    ...options,
  })

  return response
}

export default useDeleteSafetyCaseHazardMitigationMutation
